import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";

// Icons (outline + filled pairs)
import { IoHome, IoHomeOutline } from "react-icons/io5";
import { PiBookOpen, PiBookOpenFill } from "react-icons/pi";
import { PiTrophy, PiTrophyFill } from "react-icons/pi";
import { IoPerson, IoPersonOutline } from "react-icons/io5";
import menu3 from "../../../Images/Menu 3.png";
import axios from "../../../axios";
import { toast } from "react-toastify";

const BottomNavbar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [centerLoading, setCenterLoading] = useState(false);

 const isActive = (path) => {
  return location.pathname === path;
};

  const handleCenterClick = async () => {
    if (centerLoading) return;

    setCenterLoading(true);

    try {
      const userResponse = await axios.get("me");
      const userData = userResponse?.data?.result;
      const hasPurchased = Boolean(userData && userData?.planName !== "Test");

      navigate(hasPurchased ? "/dash/quize" : "/dash/mock-tests");
    } catch (error) {
      toast.error("Unable to check plan status");
      navigate("/dash/mock-tests");
    } finally {
      setCenterLoading(false);
    }
  };

  return (
    <div className="dashboard-bottom-navbar fixed bottom-2 left-0 w-full flex justify-center z-50 lg:hidden">
      
      <div className="relative w-[95%] max-w-md bg-white rounded-3xl shadow-xl border border-gray-200 px-6 py-3 flex justify-between items-center">
        
      {/* Home */}
<div
  onClick={() => navigate("/dash/home")}
  className="flex flex-col items-center text-xs cursor-pointer"
>
  {isActive("/dash/home") ? (
    <IoHome size={22} className="text-orange-500" />
  ) : (
    <IoHomeOutline size={22} className="text-gray-400" />
  )}

  <span
    className={
      isActive("/dash/home")
        ? "text-orange-500"
        : "text-gray-400"
    }
  >
    Home
  </span>
</div>
  {/* Contest */}
        <div
          onClick={() => navigate("/dash/contest")}
          className="flex flex-col items-center text-xs cursor-pointer"
        >
          {isActive("/dash/contest") ? (
            <PiTrophyFill size={22} className="text-orange-500" />
          ) : (
            <PiTrophy size={22} className="text-gray-400" />
          )}
          <span className={isActive("/dash/contest") ? "text-orange-500" : "text-gray-400"}>
            Contest
          </span>
        </div>

    

        {/* Space */}
        <div className="w-12"></div>

          {/* Course */}
        <div
          onClick={() => navigate("/dash/plan")}
          className="flex flex-col items-center text-xs cursor-pointer"
        >
          {isActive("/dash/plan") ? (
            <PiBookOpenFill size={22} className="text-orange-500" />
          ) : (
            <PiBookOpen size={22} className="text-gray-400" />
          )}
          <span className={isActive("/dash/plan") ? "text-orange-500" : "text-gray-400"}>
            Mock Test
          </span>
        </div>

        {/* Profile */}
        <div
          onClick={() => navigate("/dash/profileNew")}
          className="flex flex-col items-center text-xs cursor-pointer"
        >
          {isActive("/dash/profileNew") ? (
            <IoPerson size={22} className="text-orange-500" />
          ) : (
            <IoPersonOutline size={22} className="text-gray-400" />
          )}
          <span className={isActive("/dash/profileNew") ? "text-orange-500" : "text-gray-400"}>
            Profile
          </span>
        </div>

        {/* 🔥 Center Button */}
        <div
          onClick={handleCenterClick}
          className="absolute -top-4 left-1/2 transform -translate-x-1/2 cursor-pointer"
        >
          <div className=" rounded-full flex items-center justify-center ">
            <img
              src={menu3}
              alt="Menu 3"
              className={`text-white w-full h-full ${
                centerLoading ? "animate-pulse opacity-70" : ""
              }`}
            />
          </div>
        </div>

      </div>
    </div>
  );
};

export default BottomNavbar;
